const WORDS = [
  "Berufskraftfahrer", "Pflegefachkräfte", "Elektriker", "Schweißer", "Anlagenmechaniker SHK",
  "Köche", "Lager und Versand", "Ärztinnen und Ärzte", "Maschinenbediener", "Gebäudereinigung", "Verwaltung",
];

export const Marquee = () => (
  <section aria-label="Berufsgruppen" className="relative overflow-hidden border-y border-slate-200 bg-white py-7 md:py-9" data-testid="profession-marquee">
    <div className="marquee-track" aria-hidden="true">
      {[...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="flex items-center whitespace-nowrap px-6 md:px-10 text-3xl md:text-5xl font-semibold tracking-tight text-[color:var(--navy)]">
          {i % 3 === 1 ? <span className="font-serif-accent text-[color:var(--teal-ink)]">{w}</span> : w}
          <span className="ml-12 md:ml-20 inline-block h-2.5 w-2.5 rotate-45 bg-[color:var(--teal)]" />
        </span>
      ))}
    </div>
    <p className="sr-only">{WORDS.join(", ")}</p>
  </section>
);
